<template>
  <div class="card card-box d-block pb-3 bg-transparent shadow-none border-0">
    <slick ref="slick" :options="slickOptions">
      <div v-for="(template, key) in this.templates" class="card-body px-0 text-center">
        <b-button
          v-if="key !== 'label'"
          :id="template"
          variant="primary"
          pill
          size="sm"
          class="m-3 w-90 p-3 d-inline-block text-center font-size-sm"
          :class="{'btn-secondary': selected === template}"
          @click="select(template)"
        >
          {{$t(template) | capitalize}}
        </b-button>
      </div>
    </slick>
  </div>
</template>

<script>
  import Slick from 'vue-slick';

  export default {
    name: "templatesSlide",
    components: {Slick},
    props: ['type'],
    data() {
      return {
        templates: null,
        slickOptions: {
          adaptiveHeight: true,
          centerPadding: "60",
          centerMode: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 500,
          dots: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1
              }
            },
          ]
        },
        selected: null
      }
    },
    methods: {
      select(template) {
        this.selected = template;
        this.$emit('onSelect', template);
      }
    },
    created() {
      if (this.type === 'timesheets') {
        this.templates = this.$getConst.pages.sms_templates_names;
      } else {
        this.templates = this.$getConst.pages.freelancer_sms_templates_names;
      }
      delete this.templates.label;
    }
  }
</script>

<style scoped>
  .w-90 {
    width: 90%;
  }
</style>
